var React = require('react');

function Letter (props) {
    return React.createElement("svg",props,React.createElement("g",{"className":"nc-icon-wrapper","transform":"matrix(1, 0, 0, 1, 8, 8)"},[React.createElement("path",{"d":"M14,1H2A2,2,0,0,0,0,3v.4L8,7.9l8-4.4V3A2,2,0,0,0,14,1Z","key":0}),React.createElement("path",{"d":"M7.5,9.9,0,5.7V13a2,2,0,0,0,2,2H14a2,2,0,0,0,2-2V5.7L8.5,9.9A1.243,1.243,0,0,1,7.5,9.9Z","key":1})]));
}

Letter.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 32 32"};

module.exports = Letter;

Letter.default = Letter;
